import { languageMap } from ".."

languageMap.systemd = {
	comments: {
		line: "#",
	},
}
